var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"accordion"},_vm._l((_vm.data),function(item,index){return _c('Collapse',{key:index,attrs:{"item":item,"index":index}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }